/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../../types/QueryTags'
import { 
  createClientBulkReQuest 
} from './types'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'



interface bulkCategoryResponse {
  content: {
    id: string,
    name: string,
    description: string,
    debitAccount: string,
    debitCurrency: string,
    statusMasks: string[],
    createdDate: string,
    modifiedDate: string,
    amount: number,
    narration: string,
    validationCompleted: boolean,
  }[],
  page:{
    number: number,
    size: number,
    totalElements: number,
    totalPages: number,
  },
}

interface bulkBatch {
  bulkId: string,
  amount: number,
  narration: string,
  beneficiary: {
    account: string,
    currency: string,
    bankCode: string,
    accountOwnerNames: string,
  },
}

interface conmpleteBulkFile {
  id: string,
  otpData: {
    otpChannel: string,
    otpCode: string,
    otpIdentifier: string,
  },
}

interface bulkClearingAccountResponse {
  id:{
    clearingAccount: string,
    currency: string,
  },
}

const basePath = '/bulkService/client'

const bulkEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) => 
  ({
    fetchBulkCategories: builder.query<bulkCategoryResponse, void>({
      query: () => `${basePath}/config/filterBulkCategory`
    }),

    fetchBulkServices: builder.query<bulkCategoryResponse, void>({
      query: () => `${basePath}/config/filterBulkService`
    }),

    fetchBulkCustomerWashAccounts: builder.query<bulkClearingAccountResponse[], {customerNumber: string, currency: string,}>({
      query: ({customerNumber, currency}) => `${basePath}/clearingAccount?customerNumber=${customerNumber}&currency=${currency}`
    }),

    createClientBulk: builder.mutation<{id: string,}, createClientBulkReQuest>({
      query: (body) => ({
        url: `${basePath}/bulk`,
        method: 'POST',
        body,
      }),
    }),

    submitBulkTransactionBatch: builder.mutation<{id: string,}, string>({
      query: (body) => ({
        url: `${basePath}/transaction/batch`,
        method: 'POST',
        body,
      }),
    }),

    fetchBulkHistory: builder.query<bulkCategoryResponse, {page: number, size: number,}>({
      query: ({page, size}) => `${basePath}/bulk/filter?page=${page}&size=${size}`,
      providesTags:['bulk-history']
    }),

    fetchSignleBulkFile: builder.query<bulkCategoryResponse, {id: string | undefined,}>({
      query: ({id}) => `${basePath}/bulk/filter?id=${id}`,
      providesTags: ['bulk-records'],
    }),

    fetchBulkTransactionHistoryById: builder.query<bulkCategoryResponse, {page:number, size:number, id: string | undefined, validated?: any,}>({
      query: ({page, size, id, validated}) => `${basePath}/transaction/filter?page=${page}&size=${size}&bulkId=${id}&sort=tag,asc${validated !== undefined ? `${validated}` : ''}`,
      providesTags:['bulk-records']
    }),

    fetchBulkTransactions: builder.query<bulkCategoryResponse, {page:number, size:number, id: string | undefined,}>({
      query: ({page, size, id}) => `${basePath}/transaction/getBulkTransaction?bulkId=${id}&page=${page}&size=${size}`,
    }),

    completeBulkFile: builder.mutation<{id: string,}, conmpleteBulkFile>({
      query: (body) => ({
        url: `${basePath}/bulk/complete`,
        method: 'PUT',
        body
      }),
    }),

    updateBulkTransactionRecord: builder.mutation<{id: string,}, any>({
      query: ({bulkId, transactionId, payload}) => ({
        url: `${basePath}/transaction?bulkId=${bulkId}&transactionId=${transactionId}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['bulk-records'],
    }),

    addAsingleBulkTransaction: builder.mutation<{id: string,}, any>({
      query: (body) => ({
        url: `${basePath}/transaction`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['bulk-records'],
    }),

    deleteASingleBulkTransaction: builder.mutation<any, {bulkId: string, transactionId: string,}>({
      query: ({bulkId, transactionId}) => ({
        url: `${basePath}/transaction?bulkId=${bulkId}&transactionId=${transactionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['bulk-records'],
    }),

    deleteMultipleBulkTransactions: builder.mutation<any, {bulkId: string, payload: string[],}>({
      query: ({bulkId, payload}) => ({
        url: `${basePath}/transaction/batch?bulkId=${bulkId}`,
        method: 'DELETE',
        body: payload,
      }),
      invalidatesTags: ['bulk-records'],
    }),

    getBulkFileStatistics: builder.query<any, {bulkId: string| undefined,}>({
      query: ({bulkId}) => `${basePath}/bulk/getBulkStatistics?bulkId=${bulkId}`,
    }),

    deleteBulkFile: builder.mutation<any, {id: string,}>({
      query: ({id}) => ({
        url: `${basePath}/bulk?id=${id}`,   
        method: 'DELETE',
      }),
      invalidatesTags: ['bulk-history'],
    }),

    downloadBulkFileDetails: builder.query<bulkCategoryResponse, {page:number, size:number | undefined, id: string | undefined, validated?: boolean | undefined,}>({
      query: ({page, size, id}) => `${basePath}/transaction/filter?page=${page}&size=${size}&bulkId=${id}`,
      providesTags:['bulk-records']
    }),

    reValidatesBulkRecord: builder.mutation<any, {transactionId: string,}>({
      query: ({transactionId}) => ({
        url: `${basePath}/transaction/revalidateTransaction?transactionId=${transactionId}`,
        method: 'POST',
      }),
      invalidatesTags: ['bulk-records'],
    }),

  })

export default bulkEndpoints